import Vue from 'vue'
import Router from 'vue-router'
import auth from './auth'
import api from './services/api_endpoints'

Vue.use(Router);

function requireAuth (to, from, next) {

  if (to.query.hasOwnProperty('apptoken')) {
    if (auth.getToken() == null) {
      let token = to.query.apptoken;
      let id = api.extractUserIdFromToken(token);
      if (id !== 0) {
        auth.saveToken(token);
      }
    }
  }

  if (!auth.loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

export default new Router({
  mode:"history",
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "about" */ './views/Dashboard.vue'),
      beforeEnter: requireAuth
    },
    // {
    //   path: '/dashboard',
    //   name: 'dashboard',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/Dashboard.vue'),
    //   beforeEnter: requireAuth
    // },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter (to, from, next) {
        // console.log('beforeEnter /logout called');
        auth.logout();
        next('/login')
      },
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/ForgotPassword.vue')
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Login.vue')
    },
    {
      path: '/test',
      name: 'test',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Test.vue')
    },
    {
      path:"*",
      redirect: "/"
    }
  ]
})
